<template>
  <div>
    <h3 style="margin: 1rem 0 0 1rem;">Комментарии</h3>
    <div class="comments-page">
      <div class="filters">
        <div>
          <selection-block-category
              :getCategory="getSelectedCategories"
              :getLocationsData="getLocationsData"
          />
        </div>
        <div>
          <my-date-period-picker-analytics
              :getTime="getStartEndTime"
          />
        </div>
        <div>
          <el-button @click="getComments">Показать</el-button>
        </div>




      </div>
      <div class="comments">
        <div v-if="comments">
          <div class="comments-header">
            <div>ID звонка</div>
            <div>Кто создал</div>
            <div>Категория(id)</div>
            <div>дата создания</div>
            <div>комментарий</div>
          </div>
          <div class="comments-body">
            <div v-for="comment in comments" class="comment" @click="openAllCallInfoComments(comment.call_info_id, comment.category_id)">
              <div>{{comment.call_info_id}}</div>
              <div>{{comment.who_created_name}}</div>
              <div>{{comment.category_id ? comment.category_name+"("+comment.category_id+")" : '-'}}</div>
              <div>{{comment.created_at}}</div>
              <div>{{comment.text}}</div>
              <div></div>
            </div>
          </div>

          <call-info-comments
              ref="commentsComponent"
              :call-info-id="currentCallInfoId"
              :category-id="currentCategoryId"
              :hide-button="true"
              :visibleComments.sync="visibleComments"
          />
        </div>
        <div v-else>Комментарии отсутствуют</div>
      </div>
    </div>

  </div>
</template>

<script>
import MyDatePeriodPickerAnalytics from "@/components/analytics/basicCategoryAnalysis/myDatePeriodPickerAnalytics.vue";
import CallInfoComments from "@/components/newCatigories/callInfoComments.vue";
import SelectionBlockCategory from "@/components/analytics/basicCategoryAnalysis/SelectionBlockCategory.vue";

export default {
  name: "Comments",
  components: {SelectionBlockCategory, CallInfoComments, MyDatePeriodPickerAnalytics},

  data() {
    return {
      dates: {start: '', end: ''},
      comments: null,
      categories: null,
      selectedCategories: [],
      allDataCategoryApi: [],
      locationsData: [],
      currentCallInfoId: null,
      currentCategoryId: null,
      visibleComments: false,
    }
  },
  mounted() {
    this.getCategories()
  },
  watch: {
    selectedCategories() {
      this.allDataCategoryApi = []
      // this.selectedCategories.forEach(id => {
      //   this.getCategoryApi(id)
      // })
    },
    startEndDateForCallListAndCategoryDictionaries() {
      this.allDataCategoryApi = []
      if (this.selectedCategories && this.selectedCategories) {
        // this.selectedCategories.forEach(id => {
        //   this.getCategoryApi(id)
        // })
      }
    },
  },
  methods: {
    openAllCallInfoComments(callInfoId, categoryId){
      this.currentCallInfoId = callInfoId
      this.currentCategoryId = categoryId
      this.visibleComments =  !this.visibleComments
    },
    getLocationsData(callback) {
      return this.locationsData = callback
    },
    getSelectedCategories(callBack) {
      this.selectedCategories = callBack
    },
    getCategories() {
      this.$api.category.getCategories()
    },
    getStartEndTime(callback) {
      this.dates = callback
    },
    getComments() {
      this.$api.comments.getComments({
        date_start:this.dates.start,
        date_end: this.dates.end,
        category_ids: this.selectedCategories
      })
          .then(data => {
            this.comments = data
          })
    }
  }
}
</script>

<style scoped lang="scss">
 .comments-page {
   max-width: 100%;
   margin: 0 1rem;
   .filters {
     display: grid;
     grid-template-columns: 4fr 1fr 2fr;
     gap: 1rem;
     align-items: center;
     .el-button {
       padding: 0.5rem 1.5rem;
       margin-top: 1.9rem;
     }
   }
   >div:first-child {
     margin-top: 1rem;
   }
   .comments {
     margin-top: 1rem;
   }
   .comments-header, .comments-body > .comment {
     display: grid;
     grid-template-columns: repeat(5, 1fr);
   }
   .comments-header {
     > div {
       padding: 0.5rem 1rem;
     }
   }
   .comments-body {
     padding: 0.5rem 1rem;
     .comment {
       padding: .5rem;
       cursor: pointer;
       &:nth-child(3n-1) {
         background: #d5e3f4;
       }
       &:hover {
         background: #e7eefa;
       }
     }
   }

 }
</style>